import { NumberInputBox } from "Components/NumberInputBox";
import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

export const AptitudeTest = ({
  options,
  selectedCard,
  setSelectedCard,
  greVerbalScore,
  setGreVerbalScore,
  greQuantScore,
  setGreQuantScore,
  greAWAScore,
  setGreAWAScore,
  satReadWriteScore,
  setSatReadWriteScore,
  satMathScore,
  setSatMathScore,
  actTotalScore,
  setactTotalScore,
}) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", textAlign: "left" }}>
        Which aptitude test did you take?
      </Title>
      <Flex wrap>
        <TitleCardsList
          options={options}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
      {selectedCard === "GRE" && (
        <Flex style={{ marginTop: "24px" }}>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>Verbal</Title>
            <NumberInputBox
              value={greVerbalScore}
              placeholder={"Out of 170"}
              onChange={setGreVerbalScore}
              min={130}
              max={170}
              size={"large"}
              required={true}
            />
          </Flex>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>Quant</Title>
            <NumberInputBox
              value={greQuantScore}
              placeholder={"Out of 170"}
              onChange={setGreQuantScore}
              min={130}
              max={170}
              size={"large"}
              required={true}
            />
          </Flex>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>AWA</Title>
            <NumberInputBox
              value={greAWAScore}
              placeholder={"Out of 6"}
              onChange={setGreAWAScore}
              min={0}
              max={6}
              size={"large"}
              required={true}
            />
          </Flex>
        </Flex>
      )}
      {selectedCard === "SAT" && (
        <Flex style={{ marginTop: "24px" }}>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>Reading And Writing</Title>
            <NumberInputBox
              value={satReadWriteScore}
              placeholder={"Out of 800"}
              onChange={setSatReadWriteScore}
              min={200}
              max={800}
              size={"large"}
              required={true}
            />
          </Flex>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>Math</Title>
            <NumberInputBox
              value={satMathScore}
              placeholder={"Out of 800"}
              onChange={setSatMathScore}
              min={200}
              max={800}
              size={"large"}
              required={true}
            />
          </Flex>
        </Flex>
      )}
      {selectedCard === "ACT" && (
        <Flex style={{ marginTop: "24px" }}>
          <Flex vertical justify="flex-start" align="flex-start" flex={1}>
            <Title level={5}>Total Score</Title>
            <NumberInputBox
              value={actTotalScore}
              placeholder={"Out of 36"}
              onChange={setactTotalScore}
              min={1}
              max={36}
              size={"large"}
              required={true}
            />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
